import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  justify-content: center;
  background-color: #1a3458;
  padding: 10px 20px;
  border-bottom: 5px solid #28a137;
`;

export const Content = styled.div`
  display: flex;
  max-width: 1240px;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  > img {
    width: 50px;
  }
`;

export const Navigation = styled.nav`
  ul {
    display: flex;
    list-style: none;
    gap: 10px;
    color: white;
    font-size: 13px;

    @media (max-width: 1024px) {
      display: none;
    }
  }

  a {
    text-decoration: none;
    color: white;
  }
`;

export const SideBarContainer = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const Icon = styled.img`
  cursor: pointer;
`;
